<template lang="html">
  <div class="personal-list">
    <div class="position-fixed word-list animated h-100" id="word-list" ref="wordList">
      <div class="button-list" @click="toggleList">
        <i class="fas fa-star"></i> {{hebrew ? 'הרשימה שלי' : 'My List'}} ({{selectedWords.length}})
      </div>
      <div class="bg-white h-100 position-relative">
        <small class="d-none d-sm-block py-3 px-3" v-if="selectedWords.length < 1">
          לא קיימות מילים להצגה.
          <br />
          להוספת מילים לחץ על הכוכב שמופיע לצד המילה הרצויה בעת מעבר עכבר.
        </small>
        <small class="d-block d-sm-none py-3 px-3" v-if="selectedWords.length < 1">
          על מנת להוסיף מילה לרשימה לחצו על המילה הרצויה בטבלת התוצאות
        </small>
        <ul v-else id="selected-words" class="p-0 list-unstyled">
          <li class="px-4 py-1 f-narkis position-relative" v-for="(item, index) in selectedWords" :key="index">
            {{item}}
            <small class="rounded-circle text-center position-absolute d-none"><i class="fa fa-times"
                @click="removeFromList(item)"></i></small>
          </li>
        </ul>
      </div>
      <div class="actions position-absolute bg-background w-100 px-md-3 py-1 text-center"
        :class="{'disabled' : selectedWords.length < 1}">
        <button @click="openReset"><i class="fas fa-trash"></i></button>
        <button class="copy" @click="copyToClipboard"><i class="fas fa-copy"></i></button>
        <button @click="download"><i class="fas fa-download"></i></button>
        <ResetDialog v-model="showReset" @dialogClick="clearText" />
      </div>
    </div>

    <div id="word-added-msg" class="notify-msg text-white" style="display:none;">
      המילה התווספה לרשימה
    </div>
    <div id="word-removed-msg" class="notify-msg text-white" style="display:none;">
      המילה הוסרה מהרשימה
    </div>
    <div id="text-copied-msg" class="notify-msg text-white" style="display:none;">
      הטקסט הועתק בהצלחה
    </div>

  </div>
</template>      

<script lang="js">
import ResetDialog from "@/components/ResetDialog";
import $ from 'jquery'
export default {
  name: 'PersonalList',
  components: { ResetDialog },
  props: [],
  mounted() {
    this.DontAskAgain = localStorage.NOT_ASK === 'true'
  },
  data() {
    return {
      showReset: false,
      DontAskAgain: false
    }
  },
  methods: {
    toggleList() {
      this.$refs.wordList.classList.toggle('opened')
    },
    removeFromList(word) {
      this.$store.commit('REMOVE_WORD_FROM_LIST', word)
    },
    copyToClipboard() {
      if (this.selectedWords.length > 0) {
        const el = document.createElement('textarea')
        el.id = "copyText"
        document.body.appendChild(el)
        document.getElementById('copyText').value = this.selectedWords;
        document.activeElement.blur()
        document.getElementById('copyText').focus()
        document.getElementById('copyText').select()
        document.execCommand('copy');
        document.body.removeChild(el);
        $("#text-copied-msg").fadeIn()
        setTimeout(() => { $("#text-copied-msg").fadeOut() }, 2000)
      }
    },
    download() {
      if (this.selectedWords.length > 0) {
        var element = document.createElement('a')
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.selectedWords.join().replace(/,/g, '\n')))
        element.setAttribute('download', 'Selected Words' + '.txt')
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    },
    openReset() {
      if (this.selectedWords.length > 0) {
        if (!this.DontAskAgain) {
          this.showReset = true
        } else {
          this.clearText(true)
        }
      }
    },
    clearText(value) {
      if (value.dontShowAgain) this.DontAskAgain = true

      if (value.clicked || this.DontAskAgain) {
        this.$store.commit('CLEAR_LIST')
        $("#word-removed-msg").fadeIn()
        setTimeout(() => { $("#word-removed-msg").fadeOut() }, 2000)
      }
    }
  },
  computed: {
    hebrew() {
      return this.$settings.hebrew
    },
    selectedWords() {
      return this.$store.state.personalWords
    }
  }

}
</script>
<style lang="scss" scoped>
.word-list {
  left: -160px;
  width: 160px;
  top: 0;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
  z-index: 99999;

  &.animated {
    transition: all 0.6s ease;
  }

  #selected-words {
    height: calc(100vh - 32px);
    overflow-y: auto;
  }

  &.opened {
    left: 0;
  }

  .button-list {
    cursor: pointer;
    transform: rotate(-90deg);
    right: -100px;
    top: 143px;

    @media (max-width: 991px) {
      top: 70vh;
    }

    position:absolute;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    background: white;
    padding: 12px 20px 9px;
  }
}

.fa-star {
  color: #FFE452;
  font-size: 14px;
}

i {
  cursor: pointer;
}

.disabled {
  button {
    color: #9da3a8;
    pointer-events: none;

    i {
      cursor: default;
    }
  }
}

li {
  font-size: 20px;

  small {
    left: 10px;
    top: 10px;
    width: 20px;
    height: 20px;
    background: transparent
  }

  &:hover {
    background: #f6f6f6;

    small {
      display: inline !important;

      &:hover {
        background: #e3e3e3;
      }
    }
  }
}

.actions {
  bottom: 0;

  button {
    border: none;
    padding: 0 8px;
    margin: 0 4px;
    background: transparent;

    @media (max-width: 991px) {
      width: 33%;
      font-size: 20px;
      margin: 0;
    }

    &:hover {
      background: #e3e3e3;
    }

    &.copy {
      border-right: 1px solid #e3e3e3;
      border-left: 1px solid #e3e3e3;
    }
  }

}
</style>